export default __webpack_public_path__ + "85d548439edef5b329b9d823ba68c82d.jpg";